export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=59405206"


//////////////////
// WEBPACK FOOTER
// ./src/components/mbk/index.vue?vue&type=template&id=59405206
// module id = ZccT
// module chunks = 0